var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_API_VERSION = 'v1';
const DEFAULT_BACKEND_URL = 'https://api.novu.co';
const PACKAGE_NAME = '@novu/client';
const PACKAGE_VERSION = '2.0.0-canary.0';
const DEFAULT_USER_AGENT = `${PACKAGE_NAME}-${PACKAGE_VERSION}`;
export class HttpClient {
    constructor({ apiVersion = DEFAULT_API_VERSION, backendUrl = DEFAULT_BACKEND_URL, userAgent = DEFAULT_USER_AGENT, } = {}) {
        this.apiVersion = apiVersion;
        this.backendUrl = `${backendUrl}/${this.apiVersion}`;
        this.headers = {
            'Content-Type': 'application/json',
            'User-Agent': userAgent,
        };
    }
    setAuthorizationToken(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    disposeAuthorizationToken() {
        delete this.headers.Authorization;
    }
    updateHeaders(headers) {
        this.headers = Object.assign(Object.assign({}, this.headers), headers);
    }
    getFullResponse(url, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.doFetch(url + this.getQueryString(params));
            return yield response.json();
        });
    }
    get(url, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.doFetch(url + this.getQueryString(params));
            const data = yield response.json();
            return data.data;
        });
    }
    post(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, body = {}) {
            const response = yield this.doFetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
            });
            const hasEmptyResponse = this.checkEmptyResponse(response);
            if (hasEmptyResponse) {
                return;
            }
            const data = yield response.json();
            return data.data;
        });
    }
    patch(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, body = {}) {
            const response = yield this.doFetch(url, {
                method: 'PATCH',
                body: JSON.stringify(body),
            });
            const hasEmptyResponse = this.checkEmptyResponse(response);
            if (hasEmptyResponse) {
                return;
            }
            const data = yield response.json();
            return data.data;
        });
    }
    delete(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, body = {}) {
            const response = yield this.doFetch(url, {
                method: 'DELETE',
                body: JSON.stringify(body),
            });
            const hasEmptyResponse = this.checkEmptyResponse(response);
            if (hasEmptyResponse) {
                return;
            }
            const data = yield response.json();
            return data.data;
        });
    }
    getQueryString(params) {
        if (!params)
            return '';
        const queryString = new URLSearchParams(params);
        return `?${queryString.toString()}`;
    }
    doFetch(url_1) {
        return __awaiter(this, arguments, void 0, function* (url, options = {}) {
            const response = yield fetch(this.backendUrl + url, Object.assign(Object.assign({}, options), { headers: this.headers }));
            yield this.checkResponseStatus(response);
            return response;
        });
    }
    checkResponseStatus(response) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!response.ok) {
                const errorData = yield response.json();
                throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorData.message}`);
            }
        });
    }
    checkEmptyResponse(response) {
        if (response.status === 204) {
            return true;
        }
        return false;
    }
}
